export interface ISwapSupportedAsset {
  network: string
  token?: string | null
}

export const matchesSwapSupportedAsset = (
  network: string,
  token: string | null | undefined,
  asset: ISwapSupportedAsset
): boolean => (
  network === asset.network && (token ?? null) === (asset.token ?? null)
)

export const isSwapSupportedAsset = (
  network: string,
  token: string | null | undefined,
  assets: ISwapSupportedAsset[]
): boolean => assets.some((asset) => matchesSwapSupportedAsset(network, token, asset))
